import React from 'react';
import { getMessage } from 'util/locale';
import propTypes from 'prop-types';
import classNames from 'classnames';

// components
import PlantingFertilizerApplication from 'common/PlantingFertilizerApplication';
import ScriptName from 'common/ScriptName';
import SeedProductInputsContainer from 'products/SeedProductInputsContainer';

const baseString = 'vra-script-config-planting-inputs';
const classString = classNames({
  [`${baseString}`]: true
});
const titleClassString = classNames({
  [`${baseString}__header`]: true,
  'vra-script-config-inputs__header': true
});
const ScriptConfigPlantingInputs = ({
  displayScriptName,
  onChangePlantingFertilizerApplication,
  onChangeScriptName,
  usingLiquidIsChecked,
  validationResult
}) => (
  <section className={classString}>
    <header className={titleClassString}>{getMessage('title-text__script-config')}</header>
    <ScriptName
      displayScriptName={displayScriptName}
      onChange={onChangeScriptName}
      validationResult={validationResult}
    />
    <SeedProductInputsContainer showSeedProductSelectorTrigger={true} />
    <PlantingFertilizerApplication
      hasPlantingFertilizerApplication={usingLiquidIsChecked}
      helpTextKey={'text__planting-fertilizer-application--script-config'}
      isFormFieldset={false}
      labelTextKey={'label-text__planting-fertilizer-application'}
      onChange={onChangePlantingFertilizerApplication}
    />
  </section>
);

ScriptConfigPlantingInputs.propTypes = {
  displayScriptName: propTypes.string.isRequired,
  onChangePlantingFertilizerApplication: propTypes.func.isRequired,
  onChangeScriptName: propTypes.func.isRequired,
  usingLiquidIsChecked: propTypes.bool.isRequired,
  validationResult: propTypes.object
};
export default ScriptConfigPlantingInputs;
